// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@umijs/deps/compiled/css-loader/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loading-overplay___16ji0 {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.8);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.loading-log___1mZ5G {\n  text-align: center;\n  color: white;\n  margin-bottom: 40px;\n}\n\n.loading-content___1Kqah {\n  text-align: center;\n  color: white;\n}\n\n.qrcode___17lOI {\n  margin-top: 20px;\n  width: 200px;\n  height: 200px;\n  background-size: 100% 100%;\n}\n\n.sms___3WhGy {\n  margin-top: 20px;\n  width: 500px;\n  height: 200px;\n}\n", ""]);
// Exports
exports.locals = {
	"loading-overplay": "loading-overplay___16ji0",
	"loading-log": "loading-log___1mZ5G",
	"loading-content": "loading-content___1Kqah",
	"qrcode": "qrcode___17lOI",
	"sms": "sms___3WhGy"
};
module.exports = exports;
